import { render, staticRenderFns } from "./invoice-record.vue?vue&type=template&id=c63032b2&scoped=true"
import script from "./invoice-record.vue?vue&type=script&lang=js"
export * from "./invoice-record.vue?vue&type=script&lang=js"
import style0 from "./invoice-record.vue?vue&type=style&index=0&id=c63032b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63032b2",
  null
  
)

export default component.exports